import request from '@/utils/request'
import URL from '@/api/baseUrl'

export default class PackageTracking {
  static queryVipOceanTraceList(data = {}) {
    return request.post(`${URL.vip}/vip-ocean-order/queryVipOceanTraceList`, data)
  }
}
